import { Component, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  @Input() item: any;
  @Input() subMenuShouldOpenUp: boolean = false;
  isHovered: boolean = false;  // desktop
  isOpen: boolean = false;     // mobile tap-expand

  constructor(public router: Router, public commonService: CommonService) { }

  /** MOBILE tap — open submenu, not hide */
  toggleMobileExpand(event: MouseEvent) {
    if (!this.commonService.isMobileDevice) return;

    if (this.item?.subMenu?.length) {
      this.isOpen = !this.isOpen;
      event.stopPropagation(); // prevent unwanted closing
    } else {
      this.hide(this.item);
    }
  }

  /** Desktop hover — controlled by mouse */
  @HostListener("mouseenter", ["$event"])
  onMouseEnter(event: MouseEvent) {
    if (this.commonService.isMobileDevice) return; // ignore hover on mobile
    this.isHovered = true;
    this.calculateSubmenuDirection(event); //desktop hover submenu positioning
  }

  @HostListener("mouseleave")
  onMouseLeave() {
    if (this.commonService.isMobileDevice) return;
    this.isHovered = false;
  }

  /** Mobile + Desktop dynamic positioning */
  calculateSubmenuDirection(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const submenu = target.querySelector(".hover-content") as HTMLElement;
    if (!submenu) return;

    submenu.style.display = "block"; // temporarily show for measurement

    const rect = submenu.getBoundingClientRect();
    const screenWidth = window.innerWidth;

    submenu.classList.remove("open-left", "open-right", "open-up");

    const spaceRight = screenWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight < rect.width && spaceLeft > spaceRight)
      submenu.classList.add("open-left");
    else submenu.classList.add("open-right");

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 150 && spaceAbove > spaceBelow)
      submenu.classList.add("open-up");
  }


  hide(item: any) {
    if (this.commonService.isMobileDevice) {
      if (!item?.subMenu?.length) {
        this.commonService.isHidden = true;
      }
    }
    if (item?.url?.length) {
      this.router.navigate(item.url);
    }
  }

  onItemTap(event: MouseEvent) {
    if (!this.commonService.isMobileDevice) return; // ❌ do nothing on desktop

    if (this.item?.subMenu?.length) {
      this.isOpen = !this.isOpen;     // mobile accordion
      event.stopPropagation();
    } else {
      this.hide(this.item);
    }
  }

  // /** Decide submenu position on hover */
  // @HostListener('mouseenter', ['$event'])
  // onMouseEnter(event: MouseEvent) {
  //   this.isHovered = true;

  //   const target = event.currentTarget as HTMLElement;
  //   const submenu = target.querySelector('.hover-content') as HTMLElement;

  //   if (!submenu) return;

  //   // 1️⃣ Temporarily show submenu for correct width calculation
  //   submenu.style.display = 'block';

  //   // 2️⃣ Now measure
  //   const rect = submenu.getBoundingClientRect();
  //   const screenWidth = window.innerWidth;

  //   const spaceRight = screenWidth - rect.right;
  //   const spaceLeft = rect.left;

  //   // 3️⃣ Reset classes first
  //   submenu.classList.remove('open-left', 'open-right');
  //   submenu.classList.remove('open-up');

  //   // 4️⃣ LEFT/RIGHT Decision
  //   if (spaceRight < rect.width && spaceLeft > spaceRight) {
  //     submenu.classList.add('open-left');
  //   } else {
  //     submenu.classList.add('open-right');
  //   }

  //   // 5️⃣ UP/DOWN Decision
  //   const spaceBelow = window.innerHeight - rect.bottom;
  //   const spaceAbove = rect.top;

  //   if (spaceBelow < 150 && spaceAbove > spaceBelow) {
  //     submenu.classList.add('open-up');
  //   }
  // }

  // @HostListener('mouseleave')
  // onMouseLeave() {
  //   this.isHovered = false;
  // }
}